import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import BasesLayout from "./BasesLayout";
import BasesList from "./sections/BasesList";
import BasesStaff from "./sections/BasesStaff";
import AmenidadesCatalog from "./sections/AmenidadesCatalog";
import ReservasDashboard from "./sections/ReservasDashboard";
import ReservasCalendar from "./sections/ReservasCalendar";
import ReservasList from "./sections/ReservasList";
import RondinesDashboard from "./sections/rondines/RondinesDashboard";
import RondinesRoutes from "./sections/rondines/RondinesRoutes";
import RondinesCheckpoints from "./sections/rondines/RondinesCheckpoints";
import RondinesSchedules from "./sections/rondines/RondinesSchedules";
import RondinesRounds from "./sections/rondines/RondinesRounds";
import RondinesIncidents from "./sections/rondines/RondinesIncidents";

// Routes for the "Bases y Propiedades" apps (Bases, Amenidades & Reservas).
// Patio de Maniobras keeps its own /truck-yard route (TruckYardLayout).
export const basesRoute: RouteObject = {
  path: "/bases",
  element: <BasesLayout />,
  children: [
    { index: true, element: <Navigate to="/bases/locaciones" replace /> },
    { path: "locaciones", element: <BasesList /> },
    { path: "personal", element: <BasesStaff /> },
  ],
};

export const amenidadesRoute: RouteObject = {
  path: "/amenidades",
  element: <BasesLayout />,
  children: [
    { index: true, element: <Navigate to="/amenidades/catalogo" replace /> },
    { path: "catalogo", element: <AmenidadesCatalog /> },
  ],
};

export const reservasRoute: RouteObject = {
  path: "/reservas",
  element: <BasesLayout />,
  children: [
    { index: true, element: <Navigate to="/reservas/dashboard" replace /> },
    { path: "dashboard", element: <ReservasDashboard /> },
    { path: "calendario", element: <ReservasCalendar /> },
    { path: "reservaciones", element: <ReservasList /> },
  ],
};

// Sub app Rondines (CC-CONSOLE #1592).
export const rondinesRoute: RouteObject = {
  path: "/rondines",
  element: <BasesLayout />,
  children: [
    { index: true, element: <Navigate to="/rondines/tablero" replace /> },
    { path: "tablero", element: <RondinesDashboard /> },
    { path: "rutas", element: <RondinesRoutes /> },
    { path: "puntos", element: <RondinesCheckpoints /> },
    { path: "programacion", element: <RondinesSchedules /> },
    { path: "rondas", element: <RondinesRounds /> },
    { path: "incidencias", element: <RondinesIncidents /> },
  ],
};
